import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  ...zhLocale,
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '新增',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    upload: '上传',
    download: '下载',
    export: '导出',
    import: '导入',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    name: '名称',
    description: '描述',
    id: 'ID',
    default: '默认',
    yes: '是',
    no: '否',
    loading: '加载中...',
    noData: '暂无数据',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息'
  },
  systemRole: {
    title: '系统角色设置',
    selectGroup: '请选择分组',
    addRole: '新增角色',
    editRole: '编辑角色',
    unnamedRole: '未命名角色',
    modelPreviewNotSupported: '模型暂不支持预览',
    noModelUploaded: '未上传模型',
    uploadModel: '上传模型',
    deleteRole: '删除角色',
    confirmDelete: '确认删除该角色吗？',
    confirmDeleteTitle: '提示',
    roleName: '角色名称',
    roleDescription: '角色描述',
    selectModel: '选择模型',
    modelFormat: '模型格式',
    avatar: '头像',
    uploadAvatar: '上传头像',
    isDefault: '设为默认',
    save: '保存',
    cancel: '取消',
    edit: '编辑',
    language: '语言',
    speechRate: '语速',
    pitchRate: '音调',
    volume: '音量',
    voice: '音色',
    defaultVoice: '默认音色',
    characterBackground: '人物背景（提示词）',
    noPrompt: '暂无提示词',
    noSystemRoles: '暂无系统角色',
    clickToUpload: '点击上传',
    clickToUploadAvatar: '点击上传头像',
    avatarUploadTip: '支持 JPG、PNG 格式，文件大小不超过 2MB',
    name: '名称',
    namePlaceholder: '可为空',
    prompt: '提示词',
    promptPlaceholder: '系统提示词',
    voicePlaceholder: '如 female_1',
    languagePlaceholder: '如 zh-CN',
    inputNumberError: '请输入数值',
    getGroupListFailed: '获取分组列表失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    unknownError: '未知错误',
    deleteSuccess: '删除成功',
    setDefaultSuccess: '已设为默认',
    selectModelFile: '请选择要上传的模型文件',
    modelUploadSuccess: '模型上传成功',
    modelUploadFailed: '模型上传失败',
    avatarFormatError: '上传头像图片只能是 JPG/PNG 格式!',
    avatarSizeError: '上传头像图片大小不能超过 2MB!',
    avatarUploadSuccess: '头像上传成功',
    avatarUploadFailed: '头像上传失败',
    avatarLoadFailed: '头像图片加载失败，请重新上传',
    modelLoadFailed: '模型加载失败，请重试',
    reuploadModel: '重新上传',
    enableModelPreview: '启用模型预览',
    domestic: '国内',
    international: '国外'
  },
  system: {
    paramManagement: '系统参数管理',
    limitConfig: '限制配置',
    asrDurationLimit: 'ASR时长限制',
    asrDurationLimitDesc: 'ASR（语音识别）单次使用的最大时长限制',
    milliseconds: '毫秒',
    appDownloadUrl: '客户端APP下载地址',
    uploadApp: '上传 APP',
    llmTokenLimit: 'LLM Token限制',
    ttsTokenLimit: 'TTS Token限制',
    ttsTokenLimitDesc: 'TTS（文本转语音）单次使用的最大Token数限制',
    llmTokenLimitDesc: 'LLM（大语言模型）单次使用的最大Token数限制',
    limitValidPeriodHours: '限制有效期',
    limitValidPeriodHoursDesc: '在此时间内的使用记录计入限制',
    tokenCount: 'Token数',
    hours: '小时',
    saveSettings: '保存设置',
    uploadAfterAutoGenerate: '上传后自动生成下载地址',
    systemPrompt: 'systemPrompt',
    addLanguageFormat: '添加',
    editLanguageFormat: '编辑',
    languageCode: '语言',
    languageName: '名称',
    prompt: 'prompt',
    systemPromptTemplate: '系统提示模板',
    languageCodePlaceholder: '请输入语言代码（如：en, zh, yue, ja）',
    languageCodeDesc: '一般为 ISO 639-1 两位小写（如 en、zh、ja）；粤语与角色/TTS 一致，固定为 yue。',
    languageNamePlaceholder: '请输入语言名称（如：English, Chinese, Japanese）',
    promptPlaceholder: '请输入prompt内容，支持多行文本，使用 \\n 换行',
    promptDesc: 'prompt内容，用于指导 AI 角色的行为规范',
    systemPromptTemplatePlaceholder: '请输入系统提示模板，必须包含 %s 占位符（用于替换位置信息）',
    systemPromptTemplateDesc: '系统提示模板格式建议：LANGUAGE: {语言代码}\\nLOCATION: %s\\nMAX_TOKENS: 2000',
    // 验证错误提示
    validationLanguageCodeRequired: '请输入语言代码',
    validationLanguageCodeFormat: '须为两位小写字母或 yue（如：en, zh, yue, ja）',
    validationLanguageNameRequired: '请输入语言名称',
    validationPromptRequired: '请输入prompt',
    validationSystemPromptTemplateRequired: '请输入系统提示模板',
    validationSystemPromptTemplatePlaceholder: '系统提示模板必须包含 %s 占位符（用于替换位置信息）',
    imageAgentApiKey: '图像处理 Agent API Key',
    imageAgentModel: '图像处理 Agent 模型',
    version: '版本号',
    versionPlaceholder: '请输入版本号',
    catalogSize: '目录大小',
    catalogHash: '目录哈希值',
    catalogHashPlaceholder: '请输入目录哈希值',
    catalogUrl: '目录URL',
    catalogUrlPlaceholder: '请输入目录URL',
    bytes: '字节',
    toolAgentApiKey: '工具 Agent API Key',
    toolAgentApiKeyPlaceholder: '请输入工具 Agent API Key',
    toolAgentModel: '工具 Agent 模型',
    toolAgentModelPlaceholder: '请输入工具 Agent 模型',
    actionAgentApiKey: '动作 Agent API Key',
    actionAgentApiKeyPlaceholder: '请输入动作 Agent API Key',
    actionAgentModel: '动作 Agent 模型',
    actionAgentModelPlaceholder: '请输入动作 Agent 模型',
    qwenConfig: 'Qwen 配置',
    qwenApiKey: 'Qwen API Key',
    qwenApiKeyPlaceholder: '请输入Qwen API Key',
    qwenApiUrl: 'Qwen API URL',
    qwenApiUrlPlaceholder: '请输入Qwen API URL',
    qwenModel: 'Qwen 模型',
    qwenModelPlaceholder: '请输入Qwen 模型',
    qwenTtsApiKey: 'Qwen TTS API Key',
    qwenTtsApiKeyPlaceholder: '请输入Qwen TTS API Key',
    qwenTtsModel: 'Qwen TTS 模型',
    qwenTtsModelPlaceholder: '请输入Qwen TTS 模型',
    qwenAsrApiKey: 'Qwen ASR API Key',
    qwenAsrApiKeyPlaceholder: '请输入Qwen ASR API Key',
    qwenAsrModel: 'Qwen ASR 模型',
    qwenAsrModelPlaceholder: '请输入Qwen ASR 模型',
    ttskey: '克隆声音专用 TTS API Key',
    ttskeyPlaceholder: '请输入克隆声音专用 TTS API Key',
    ttsmodel: '克隆声音专用 TTS 模型',
    ttsmodelPlaceholder: '请输入克隆声音专用 TTS 模型',
    environment: '环境',
    environmentDomestic: '国内',
    environmentOverseas: '国外',
    environmentUnknown: '未知'
  },
  home: {
    home: '首页',
    modelCommunity: '模型社区',
    creationCenter: '创作中心',
    createNewCharacter: '创建新人物',
    myRoleLibrary: '我的角色库',
    myFriends: '我的好友',
    llmModel: '热词设定',
    voiceSettings: '声音设定',
    myVoiceLibrary: '我的声音库',
    roomDesign: '房间设计',
    actionLibrary: '动作库',
    systemRoleSettings: '系统角色设置',
    voiceSettings: '声音克隆',
    systemParam: '系统参数',
    usageLog: '使用日志',
    timePlanMenu: '时长套餐',
    usagePlanMenu: '用量套餐',
    deviceInfoMenu: '设备信息',
    userManageMenu: '平台用户',
    orderManageMenu: '平台订单',
    logout: '退出登录',
    aimeeCommunity: '爱莓社区(测试版)',
    community: '社区'
  },
  login: {
    title: '用户登录',
    codeLogin: '验证码登录',
    passwordLogin: '密码登录',
    phonePlaceholder: '请输入手机号',
    emailPlaceholder: '请输入邮箱',
    codePlaceholder: '请输入验证码',
    passwordPlaceholder: '请输入密码',
    getCode: '获取验证码',
    resendAfter: 's后重新获取',
    login: '登录',
    forgotPassword: '忘记密码',
    register: '注册账号',
    phoneRequired: '请输入手机号',
    phoneFormatError: '请输入正确的手机号格式',
    emailRequired: '请输入邮箱',
    emailFormatError: '请输入正确的邮箱格式',
    codeRequired: '请输入验证码',
    codeFormatError: '请输入6位数字验证码',
    passwordRequired: '请输入密码',
    passwordLengthError: '密码长度在6-20个字符之间',
    codeSent: '验证码已发送，请注意查收',
    codeError: '验证码错误或已过期，请重试',
    loginSuccess: '登录成功',
    loginError: '手机号或密码错误，请重试',
    loginErrorEmail: '邮箱或密码错误，请重试',
    networkError: '网络错误，请稍后重试',
    getCodeError: '获取验证码失败，请重试'
  },
  forgotPassword: {
    title: '找回密码',
    step1: '验证邮箱',
    step2: '重置密码',
    step3: '完成',
    emailPlaceholder: '请输入注册邮箱',
    sendCode: '发送验证码',
    verifyCodePlaceholder: '请输入验证码',
    newPasswordPlaceholder: '请输入新密码',
    resetPassword: '重置密码',
    successTitle: '密码重置成功！',
    successMessage: '请使用新密码登录系统',
    backToLogin: '返回登录',
    emailRequired: '请输入邮箱地址',
    emailFormatError: '请输入正确的邮箱地址',
    verifyCodeRequired: '请输入验证码',
    verifyCodeLengthError: '验证码长度为6位',
    newPasswordRequired: '请输入新密码',
    passwordLengthError: '长度在 6 到 20 个字符',
    codeSent: '验证码已发送到您的邮箱',
    resetSuccess: '密码重置成功',
    resetError: '密码重置失败，请重试',
    networkError: '网络错误，请稍后重试'
  },
  register: {
    title: '用户注册',
    phonePlaceholder: '请输入手机号',
    emailPlaceholder: '请输入邮箱',
    codePlaceholder: '请输入验证码',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请确认密码',
    getCode: '获取验证码',
    resendAfter: 's后重新获取',
    register: '注册',
    hasAccount: '已有账号？立即登录',
    phoneRequired: '请输入手机号',
    phoneFormatError: '请输入正确的手机号格式',
    emailRequired: '请输入邮箱',
    emailFormatError: '请输入正确的邮箱格式',
    codeRequired: '请输入验证码',
    codeFormatError: '请输入6位数字验证码',
    passwordRequired: '请输入密码',
    passwordLengthError: '密码长度在6-20个字符之间',
    confirmPasswordRequired: '请再次输入密码',
    passwordMismatch: '两次输入密码不一致',
    codeSent: '验证码已发送，请注意查收',
    registerSuccess: '注册成功，即将跳转到登录页',
    registerError: '注册失败，请重试',
    networkError: '网络错误，请稍后重试',
    getCodeError: '获取验证码失败，请重试'
  },
  usageLog: {
    title: '用户使用记录',
    listTitle: '使用记录列表',
    exportData: '导出数据',
    userSN: '用户SN',
    userId: '用户ID',
    userSNPlaceholder: '请输入用户SN',
    timeRange: '时间范围',
    quickSelect: '快速选择',
    quickSelectPlaceholder: '快速选择时间',
    today: '今天',
    yesterday: '昨天',
    last7days: '最近7天',
    last30days: '最近30天',
    thisMonth: '本月',
    lastMonth: '上月',
    query: '查询',
    reset: '重置',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    statistics: '用户统计信息',
    totalAsrDuration: '总ASR时长',
    totalLlmTokens: '总LLM Token',
    totalTtsTokens: '总TTS Token',
    totalUsageCount: '总使用次数',
    sn: 'SN',
    usageTime: '使用时间',
    asrDuration: 'ASR时长',
    llmTokens: 'LLM Token',
    ttsTokens: 'TTS Token',
    usageType: '使用类型',
    asr: 'ASR',
    llm: 'LLM',
    tts: 'TTS',
    input: '输入',
    output: '输出',
    total: '总计'
  },
  timePlan: {
    title: '时长套餐管理',
    add: '新增套餐',
    edit: '编辑',
    delete: '删除',
    name: '名称',
    originalPrice: '原价',
    salePrice: '现价',
    validityPeriod: '有效期（天）',
    namePlaceholder: '请输入套餐名称',
    operation: '操作',
    loadError: '加载列表失败',
    saveSuccess: '保存成功',
    deleteSuccess: '已删除',
    confirmDelete: '确定删除该时长套餐吗？',
    tip: '提示',
    nameRequired: '请输入名称',
    validityRequired: '有效期须大于 0'
  },
  usagePlan: {
    title: '用量套餐（等级）',
    cardNormal: '普通用户',
    cardVip: 'VIP 用户',
    emptySlot: '暂无套餐数据，请先在数据库中维护 plan 表',
    edit: '编辑',
    name: '等级名称',
    asrDurationLimit: 'ASR 时长上限',
    ttsTokenLimit: 'TTS Token 上限',
    llmTokenLimit: 'LLM Token 上限',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    createTime: '创建时间',
    updateTime: '更新时间',
    namePlaceholder: '请输入等级名称',
    operation: '操作',
    asrMsHint: '单位：毫秒（ms）',
    loadError: '加载列表失败',
    saveSuccess: '保存成功',
    nameRequired: '请输入名称',
    asrRequired: '请填写 ASR 时长上限',
    ttsRequired: '请填写 TTS Token 上限',
    llmRequired: '请填写 LLM Token 上限',
    statusRequired: '请选择状态'
  },
  deviceInfo: {
    title: '设备信息管理',
    add: '新增设备',
    edit: '编辑',
    delete: '删除',
    deviceSn: '设备 SN',
    deviceSys: '设备系统',
    deviceType: '设备类型',
    deviceInfoJson: '设备信息 JSON',
    deviceSnPlaceholder: '请输入设备序列号',
    deviceSysPlaceholder: '如 Android / iOS',
    deviceTypePlaceholder: '设备型号或类型',
    jsonPlaceholder: '可选，完整设备信息 JSON',
    createTime: '创建时间',
    updateTime: '更新时间',
    operation: '操作',
    loadError: '加载列表失败',
    saveSuccess: '保存成功',
    deleteSuccess: '已删除',
    confirmDelete: '确定删除该设备信息吗？',
    tip: '提示',
    snRequired: '请输入设备 SN'
  },
  userManage: {
    title: '平台用户',
    userId: '用户ID',
    nickname: '昵称',
    nicknamePlaceholder: '模糊搜索昵称',
    phone: '手机号',
    phonePlaceholder: '模糊搜索手机号',
    email: '邮箱',
    emailPlaceholder: '模糊搜索邮箱',
    deviceSn: '设备SN',
    status: '状态',
    source: '来源',
    planId: '用量套餐',
    planTierColumn: '套餐',
    planTierFilter: '套餐',
    planTierNormal: 'Normal',
    planTierVip: 'VIP',
    vipStartTime: 'VIP 起始',
    vipEndTime: 'VIP 到期',
    planPlaceholder: '请选择套餐',
    query: '查询',
    reset: '重置',
    all: '全部',
    createTime: '注册时间',
    operation: '操作',
    edit: '编辑',
    recharge: '充值',
    rechargeTitle: '充值时长',
    rechargeUser: '用户',
    customDays: '天数',
    customDaysPlaceholder: '请输入天数',
    customDaysHint: '1～3650 天',
    customDaysRequired: '请输入有效的自定义天数',
    customDaysTooLarge: '单次最多充值 3650 天',
    rechargeSuccess: '充值成功，当前权益到期时间：{end}',
    loadError: '加载列表失败',
    saveSuccess: '保存成功',
    statusNormal: '正常',
    statusDisabled: '禁用',
    sourceWeb: 'Web',
    sourceMp: '小程序',
    gender: '性别',
    genderPlaceholder: '可选',
    genderFemale: '女',
    genderMale: '男',
    birthday: '生日',
    birthdayPlaceholder: '可选',
    nicknameRequired: '请输入昵称',
    statusRequired: '请选择状态',
  },
  orderManage: {
    title: '平台订单',
    orderNo: '订单号',
    orderNoPlaceholder: '模糊搜索订单号',
    userId: '用户ID',
    userIdPlaceholder: '精确',
    userName: '昵称',
    userNamePlaceholder: '模糊搜索昵称',
    status: '状态',
    type: '类型',
    amount: '订单金额',
    paidAmount: '实付金额',
    timePlanName: '时长套餐',
    createTime: '创建时间',
    payTime: '支付时间',
    startTime: '权益开始',
    endTime: '权益结束',
    createTimeRange: '创建时间',
    to: '至',
    startDate: '开始',
    endDate: '结束',
    query: '查询',
    reset: '重置',
    all: '全部',
    statusPending: '待支付',
    statusActive: '进行中',
    statusDone: '已完成',
    statusCancelled: '已取消',
    typeMember: '会员',
    typeGoods: '商品',
    typeRecharge: '充值',
    loadError: '加载列表失败'
  },
  voiceSettings: {
    title: '声音克隆',
    voiceList: '音色列表',
    totalCount: '共 {count} 条记录',
    voiceId: '音色ID',
    voiceName: '音色名称',
    model: '模型名称',
    speechRate: '语速',
    pitchRate: '音高',
    voiceType: '声音类型',
    systemVoice: '系统声音',
    customVoice: '用户自定义声音',
    status: '状态',
    audioFile: '音频文件',
    play: '播放',
    createTime: '创建时间',
    updateTime: '更新时间',
    loadError: '加载音色列表失败',
    networkError: '网络错误，请稍后重试',
    noAudioFile: '暂无音频文件',
    playError: '播放音频失败',
    audioPreview: '音频预览',
    index: '序号',
    addVoice: '添加音色',
    addMethod: '添加方式',
    addMethodRequired: '请选择添加方式',
    uploadAudio: '上传音频',
    uploadAudioDesc: '上传本地音频文件来克隆音色',
    manualVoiceId: '手动输入ID',
    manualVoiceIdDesc: '输入已有的音色ID进行绑定',
    addVoiceTip: '添加音色功能开发中...',
    voiceNamePlaceholder: '请输入音色名称',
    voiceNameRequired: '请输入音色名称',
    voiceNameMaxLength: '音色名称不能超过50个字符',
    audioFileRequired: '请上传音频文件',
    uploaded: '已上传',
    reupload: '重新上传',
    audioFormatError: '仅支持 MP3、WAV 格式的音频文件',
    audioSizeError: '音频文件大小不能超过 20MB',
    audioSizeErrorUser: '音频文件大小不能超过 20MB',
    uploadDurationHint: '建议音频时长不超过 {seconds} 秒',
    audioDurationReadFailed: '无法读取音频时长，请更换音频文件后重试',
    audioDurationLimitExceeded: '音频时长超过限制（最多 {seconds} 秒），请裁剪后重试',
    uploadSuccess: '音频上传成功',
    uploadFailed: '音频上传失败',
    addVoiceSuccess: '添加音色成功',
    addVoiceFailed: '添加音色失败',
    // 声音克隆页面
    name: '名称',
    namePlaceholder: '请输入名称',
    nameExists: '名称已存在，请使用其他名称',
    nameRequired: '请输入名称',
    nameMaxLength: '名称不能超过10个字符',
    audioFileRequiredForClone: '请先上传音频文件',
    saveToLibrary: '保存到声音库',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    uploadHint: '拖拽到此区域上传或点击上传',
    uploadFormatHint: '支持格式：MP3、WAV（最大20MB）',
    pitchRateLabel: '音调',
    speechRateLabel: '语速',
    // 我的声音库页面
    myVoiceLibrary: '我的声音库',
    operationGuide: '操作指引',
    viewOperationGuide: '查看操作指引',
    systemVoiceLibrary: '系统声音库',
    index: '序号',
    voiceName: '声音名称',
    category: '类别',
    gender: '性别',
    status: '状态',
    operation: '操作',
    male: '男性',
    female: '女性',
    system: '系统',
    created: '创建',
    enabled: '启用',
    disabled: '禁用',
    unknown: '未知',
    edit: '编辑',
    delete: '删除',
    noVoiceData: '暂无声音数据',
    audioPreview: '声音预览',
    editVoice: '编辑声音',
    previewTextPlaceholder: '请输入预览文本（支持中英日韩法西意德等多语言及标点符号，最多20字符）',
    voicePreview: '声音预览',
    save: '保存',
    noSystemVoiceData: '暂无系统声音数据',
    useSystemVoice: '使用系统声音',
    use: '使用',
    saveToMyVoiceLibrary: '保存到我的声音库',
    previewTextRequired: '请输入预览文本',
    voiceIdNotExists: '声音ID不存在',
    playAudioFailed: '播放音频失败，请检查音频格式',
    previewFailed: '预览失败',
    editSuccess: '编辑成功',
    editFailed: '编辑失败',
    deleteConfirm: '确定要删除这个声音吗？',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    noAudioFile: '该声音暂无音频文件',
    getVoiceListFailed: '获取声音列表失败',
    getSystemVoiceListFailed: '获取系统声音列表失败',
    saveToMyVoiceLibrarySuccess: '保存到我的声音库成功',
    saveFailed2: '保存失败',
    prevStep: '上一步',
    nextStep: '下一步',
    finish: '完成',
    welcomeToMyVoiceLibrary: '欢迎使用我的声音库',
    myVoiceLibraryDescription: '这里是您管理所有声音的地方。您可以查看、编辑、播放和删除您创建的声音。',
    systemVoiceLibraryDescription: '点击右上角的"系统声音库"按钮，可以查看系统提供的声音模板。',
    voiceListTitle: '声音列表',
    voiceListDescription: '这里显示您创建的所有声音。您可以对每个声音进行编辑、播放或删除操作。',
    operationButtons: '操作按钮',
    operationButtonsDescription: '每个声音都有操作按钮：编辑可以修改声音名称，播放可以试听声音效果，删除可以移除不需要的声音。',
    namePlaceholderForEdit: '请输入声音名称'
  },
  dashboard: {
    title: '控制台',
    totalUsers: '用户总数',
    totalOrders: '订单总数',
    sales: '销售额',
    messages: '消息'
  },
  createRole: {
    name: '名称',
    namePlaceholder: '请输入名称',
    gender: '性别',
    selectGender: '请选择性别',
    genderFemale: '女',
    genderMale: '男',
    genderRequired: '请选择性别',
    characterBackground: '人物背景设定（提示词）',
    promptPlaceholder: '请输入提示词',
    characterVoice: '人物声音',
    selectVoice: '下拉选择人物声音',
    setVoice: '设定声音',
    wakeWord: '唤醒热词',
    selectWakeWord: '下拉选择热词',
    setWakeWord: '设定热词',
    characterModel: '人物模型',
    uploaded: '已上传',
    reupload: '重新上传',
    dragOrClick: '拖拽到此区域上传或点击上传',
    modelPreview: '模型预览',
    uploadYourModel: '上传你的模型吧',
    saveToLibrary: '保存到角色库',
    apply: '应用',
    youngMale: '青年男声',
    youngFemale: '青年女声',
    middleMale: '中年男声',
    middleFemale: '中年女声',
    missingModelId: '缺少模型 ID',
    loadEditDataSuccess: '已加载编辑数据',
    loadFailed: '加载失败',
    networkError: '网络错误',
    modelLoadFailed: '模型加载失败，请重试',
    uploadModelError: '请上传 .fbx 或 .vrm 格式的模型文件',
    modelLoaded: '已加载本地模型：{name}',
    nameRequired: '请输入角色名称',
    nameMaxLength: '角色名称不能超过10个字符',
    promptRequired: '请输入人物背景设定（提示词）',
    promptMaxLength: '提示词不能超过1000个字符',
    voiceRequired: '请选择人物声音',
    wakeWordRequired: '请选择唤醒热词',
    modelFileRequired: '请先选择并上传模型文件',
    createSuccess: '角色创建成功！',
    createFailed: '创建失败，请稍后重试',
    operationFailed: '操作失败，请检查网络或稍后重试',
    language: '语言',
    forcedOutputLanguage: '强制输出语言',
    selectLanguage: '请选择语言',
    selectForcedOutputLanguage: '可选，不选则不限制输出语言',
    forcedOutputLanguageYueVoiceHint: '当前为粤语音色，语音输出必须为粤语。',
    languageRequired: '请选择语言',
    languageChinese: '中文',
    languageJapanese: '日语',
    languageKorean: '韩语',
    languageEnglish: '英语',
    languageFrench: '法语',
    languageSpanish: '西班牙语',
    languageItalian: '意大利语',
    languageGerman: '德语',
    languageCantonese: '粤语（广东话）'
  },
  myModels: {
    completed: '已完成',
    modelPreviewNotSupported: '模型暂不支持预览',
    characterVoice: '人物声音',
    defaultVoice: '默认音色',
    format: '格式',
    characterBackground: '人物背景（提示词）',
    chatLog: '聊天日志（长期记忆）',
    edit: '编辑',
    apply: '应用',
    noModels: '暂无模型，请上传新模型。',
    getListFailed: '获取模型列表失败',
    deleteConfirmTitle: '提示',
    deleteConfirmMessage: '确定要删除该角色吗？删除后不可恢复。',
    confirmDelete: '确定',
    cancelDelete: '取消',
    deleteSuccess: '角色删除成功',
    deleteFailed: '角色删除失败'
  },
  voiceModels: {
    languageSettings: '人物语言设置',
    maxResponseLength: '人物角色回答的最长长度',
    briefDescription: '精简描述（20字）',
    detailedDescription: '事无巨细（100字）',
    responseSpeed: '回答速度',
    fast: '快速',
    normal: '正常',
    slow: '较慢',
    hotWordSettings: '热词设置',
    wakeWord: '唤醒词',
    wakeWordPlaceholder: '你好艾米',
    interruptConversation: '打断对话',
    interruptPlaceholder: '打断一下',
    endConversation: '结束对话',
    endPlaceholder: '好的再见',
    specialPhrase: '特殊短语语音识别',
    specialPhrasePlaceholder: '苏超比赛',
    specialPhraseDefault: '鸣人',
    add: '添加',
    hotWordLibrary: '热词库',
    sequence: '序号',
    hotWord: '热词',
    category: '类别',
    operation: '操作',
    delete: '删除'
  },
  voiceSetting: {
    createVoice: '创建声音',
    name: '名称',
    namePlaceholder: '艾米声音',
    pitch: '音调',
    speechRate: '语速',
    gender: '性别',
    female: '女',
    male: '男',
    sampleText: '样例文本',
    sampleTextPlaceholder: '样例文本',
    voicePreview: '声音预览',
    saveToVoiceLibrary: '保存到声音库',
    cloneVoice: '克隆声音',
    cloneNamePlaceholder: '你好艾米',
    dragOrClick: '拖拽到此区域上传或点击上传',
    voiceLibrary: '声音库',
    sequence: '序号',
    voice: '声音',
    category: '类别',
    operation: '操作',
    edit: '编辑',
    delete: '删除'
  }
}

